import { LOGIN, LOGOUT, ADD_ROWS_PER_PAGE, COLOR_PALETTES } from "../constants";

const initState = {};

const auth = (state = initState, action) => {
  const userData = JSON.parse(localStorage.getItem("user")) || {};
  const { type, payload } = action;

  switch (type) {
    case LOGIN: {
      return {
        ...state,
        ...payload,
      };
    }
    case ADD_ROWS_PER_PAGE: {
      userData.row_count = payload;
      localStorage.setItem("user", JSON.stringify(userData));
      return {
        ...state,
        row_count: payload,
      };
    }

    case LOGOUT: {
      return {
        ...initState,
      };
    }
    default: {
      if (Object.keys(userData).length === 0) {
        return state;
      } else {
        return {
          ...userData,
        };
      }
    }
  }
};

export default auth;
